<ion-header class="ion-no-border" *ngIf="!isFullscreen">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" (click)="closePage()"></ion-back-button>
    </ion-buttons>
    <ion-title>CRM</ion-title>

    @if(wawiConnectorSrv.connector.executable){
      <ion-buttons slot="end">
        <ion-button style="box-shadow: none;" (click)="openExternal()">
          <ion-icon slot="icon-only" name="wawitogo"></ion-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>
</ion-header>

<ion-content NoScrollbar>
  <app-crm-detail></app-crm-detail>
</ion-content>
